import { useState } from 'react';
import { Box, Tab, Tabs, Paper, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import OptionFactBank from './OptionFactBank';
import OptionFactSelectedList from './OptionFactSelectedList';

function DisDatQuestionEditor({ questionData, onChangeQuestion }) {


    const [tabIndex, setTabIndex] = useState(0);
    const [warningOpen, setWarningOpen] = useState(false);
    const question = questionData?.[0];
    const questionParams = question?.criteria?.questionParams || {};


    const disDatSelection = {
        type: questionParams.disDatType || '',
        selectedArtistOrGroup: questionParams.quizzlerEntity || null,
        entity1: questionParams.option1QVariable || null,
        entity2: questionParams.option2QVariable || null,
        customInstructions: questionParams.customInstructions || ''
    };


    const selectedOFQOList = questionParams.optionFactQVariableList || [];

    const updateQuestion = (updatedSelection = {}, updatedFacts = selectedOFQOList) => {
        const questionParams = {
            ...(updatedSelection.selectedArtistOrGroup && {
                quizzlerEntity: updatedSelection.selectedArtistOrGroup
            }),
            option1QVariable: updatedSelection.entity1 || null,
            option2QVariable: updatedSelection.entity2 || null,
            disDatType: updatedSelection.type || '',
            customInstructions: updatedSelection.customInstructions || '',
            optionFactQVariableList: updatedFacts || [],
            type: 'DisDatQuestionParams'
        };

        onChangeQuestion({
            question: { templateId: 'disDatTemplate', 'type': 'DIS_DAT' },
            criteria: { questionParams, 'type': 'DisDatQuestionCriteria' },
            type: 'DIS_DAT'
        });
    };

    const handleSelectionChange = ({ type, selectedArtistOrGroup, entity1, entity2, customInstructions }) => {



        updateQuestion({ type, selectedArtistOrGroup, entity1, entity2, customInstructions });
    };



    const getQvId = (fact) => {


        const idMapping = fact?.ofqo?.correctOption?.qv?.quizzlerObject?.idMapping;
        return idMapping?.WIKIDATA || idMapping?.MUSICBRAINZ || null;
    };

    const handleSelectFact = (newFact) => {



        console.log(newFact);

        // Extract QV ID from newFact
        const newQvId = getQvId(newFact);



        // Build a Set of unique QV IDs from the selected list
        const selectedQvIds = new Set(
            selectedOFQOList
                .map(getQvId)
                .filter(Boolean) // skip nulls
        );

        // If we already have 2 unique QVs and new one doesn't match either, reject
        if (selectedQvIds.size >= 2 && !selectedQvIds.has(newQvId)) {
            setWarningOpen(true);
            return;
        }

        updateQuestion(disDatSelection, [...selectedOFQOList, newFact]);
    };

    const handleUpdateSelectedList = (newList) => {


        updateQuestion(disDatSelection, newList);
    };

    return (
        <Box sx={{ height: '100%' }}>
            <Box sx={{ display: 'flex', gap: '200px' }}>
                <Typography variant="h6">DisDat Facts</Typography>
            </Box>

            <Box sx={{ height: 3 }} />

            <Paper elevation={10} sx={{ height: '92%', overflowY: 'hidden', p: '10px 20px 20px 30px' }}>
                <Tabs value={tabIndex} onChange={(e, i) => setTabIndex(i)}>
                    <Tab label="Generated" />
                    <Tab label="Selected" />
                </Tabs>

                <Box sx={{ height: 20 }} />

                <Box sx={{ display: tabIndex === 0 ? 'block' : 'none', height: '100%' }}>
                    <OptionFactBank
                        onSelectFact={handleSelectFact}
                        onSelectionChange={handleSelectionChange}
                        disDatSelection={disDatSelection}
                    />
                </Box>

                <Box sx={{ display: tabIndex === 1 ? 'block' : 'none', height: '100%' }}>
                    <OptionFactSelectedList
                        selectedList={selectedOFQOList}
                        onUpdateSelectedList={handleUpdateSelectedList}
                        disDatSelection={disDatSelection}
                    />
                </Box>
            </Paper>

            <Dialog open={warningOpen} onClose={() => setWarningOpen(false)}>
                <DialogTitle>Facts were already selected for other entities</DialogTitle>
                <DialogContent>
                    Either revert to the original entities, or clear the selected list
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setWarningOpen(false)} color="primary" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

export default DisDatQuestionEditor;
